import { cn } from '~/shadcn/lib/utils'

type Props = {
  label: string
  value: React.ReactNode | string
  className?: string
  labelClassName?: string
  contentClassName?: string
}

function LabelValueItem({
  label,
  value,
  className,
  labelClassName,
  contentClassName,
}: Props) {
  return (
    <div
      className={cn(
        'flex flex-col justify-between sm:flex-row sm:items-center',
        className
      )}>
      <ItemLabel className={labelClassName}>{label}</ItemLabel>
      <ItemContent className={contentClassName}>{value}</ItemContent>
    </div>
  )
}

const ItemLabel = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div
    className={cn('text-md leading-normal text-muted w-[250px]', className)}
    {...props}
  />
)

const ItemContent = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div
    className={cn('text-md leading-normal text-primary', className)}
    {...props}
  />
)

export { LabelValueItem }
